import { createApp } from 'vue'
import router from './router/index'
import App from './App.vue'
import { createVuetify } from 'vuetify'
import 'vuetify/dist/vuetify.min.css'
import '@mdi/font/css/materialdesignicons.css'
// import { sync } from 'vuex-router-sync'
import store from '@/store/store'
import jsonCSV from 'vue-json-csv'

//Vue.config.productionTip = false
const vuetify = createVuetify({})

// sync(store, router)

const app = createApp(App);
app.use(vuetify)
app.use(router)
app.use(store)
app.component('downloadCsv', jsonCSV)
app.mount('#app')
